import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
const CHECKOUT_URL = 'https://the-no-prep-chess-club-megapack.impultienda.ar/checkout';
const included = ['6 complete volumes', '5 instant-use bonuses', '300 print-ready pages', '71 word-for-word session plans', '69 printable worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-168" data-mp="1rsye44yqxvvd">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-169" data-mp="25t94z8023agj">
        <div className="text-center" data-id="element-170" data-mp="20tegfb3r6wyn">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-171" data-mp="20sd4l4ewy6fv">
            Complete package
          </p>
          <h2 id="pricing-heading" className="chalk-underline mt-3 font-display text-ink text-[28px] sm:text-5xl" data-id="element-172" data-mp="3h9hc7mqfn9yj">
            Everything you need for the whole season
          </h2>
        </div>

        <div className="clip-corner mt-8 overflow-hidden rounded-3xl border border-ice-dark bg-white shadow-card" data-id="element-173" data-mp="4svvrpspr2sv">
          <div className="bg-navy px-5 py-5 text-center" data-id="element-174" data-mp="9rz2rfs97j3h">
            <h3 className="font-display text-xl text-white sm:text-2xl" data-id="element-175" data-mp="9qe7tp211y53">
              The No-Prep Chess Club Megapack
            </h3>
            <p className="mt-1 text-[13px] font-bold text-gold" data-id="element-176" data-mp="3d9qmy805eyr4">
              Complete Package · 6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-177" data-mp="3i5xx6czkuwev">
            <div className="rounded-xl bg-cream" data-id="element-178" data-mp="3n6ljilcv2p2r">
              <ProductVisual data-id="element-179" data-mp="3n5u0sb4d4ltw" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-180" data-mp="3rydfjbesdn0a">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-181" data-mp="2uj9a7cvpodre">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-green/15" data-id="element-182" data-mp="2zhas3uhei71a">
                    <CheckIcon className="h-3 w-3 text-green" aria-hidden="true" data-id="element-183" data-mp="2rftdidf81ngp" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-184" data-mp="318in12r7or9e">
              <p className="text-[13px] text-ink-soft" data-id="element-185" data-mp="2w8d205fg630a">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-186" data-mp="28iipxq2ycih3">$106 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-187" data-mp="23k7e59t3jxw8">
                <span className="mt-2.5 font-display text-3xl" data-id="element-188" data-mp="2iggc88194572">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-189" data-mp="2dh3gexsejnsc">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-190" data-mp="3tuk4n9s6xla0">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-191" data-mp="3ovz6rh0evdoq">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-192" data-mp="9m0obr0ji81">
                  Save $79
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-193" data-mp="3ng4ubyid8ivl">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-194" data-mp="j1wmstxg71jg">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-195" data-mp="a81qmbeb0lfy">
                Get the Megapack now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-196" data-mp="11zr37t0wofbv">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-197" data-mp="16qpoz84ny5mi">
                <li className="flex items-center gap-1.5" data-id="element-198" data-mp="3f8bhyi6hj9ti">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-199" data-mp="3a8p4c7mqvrk6" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-200" data-mp="35a44wafbhbws">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-201" data-mp="3180r3f56dv8c" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-202" data-mp="1rax6e97zhaj">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-203" data-mp="3syeyqtmlibbk" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-204" data-mp="3k7epc99xts4n">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}